import Input from "../../../components/common/Input";
import Select from "../../../components/common/Select";
import Button from "../../../components/common/Button";

import {
  OFFER_STATUS
} from "../constants/offer.constants";

const OfferFilters = ({
  filters,
  onChange,
  onReset,
  clients = [],
  queries = []
}) => {
  const statusOptions =
    Object.values(
      OFFER_STATUS
    ).map((status) => ({
      value: status,
      label:
        status.charAt(0) +
        status
          .slice(1)
          .toLowerCase()
    }));

  const clientOptions =
    clients.map((client) => ({
      value: client.id,
      label:
        client.company_name ||
        client.name ||
        client.email
    }));

  const queryOptions =
    queries.map((query) => ({
      value: query.id,
      label:
        query.subject ||
        query.message ||
        query.id
    }));

  const handleChange = (event) => {
    const {
      name,
      value
    } = event.target;

    onChange({
      ...filters,
      [name]: value
    });
  };

  return (
    <div className="offer-filters">
      <Select
        label="Status"
        name="status"
        value={
          filters.status || ""
        }
        onChange={handleChange}
        options={statusOptions}
        placeholder="All statuses"
      />

      <Select
        label="Client"
        name="clientId"
        value={
          filters.clientId || ""
        }
        onChange={handleChange}
        options={clientOptions}
        placeholder="All clients"
      />

      <Select
        label="Query"
        name="queryId"
        value={
          filters.queryId || ""
        }
        onChange={handleChange}
        options={queryOptions}
        placeholder="All queries"
      />

      <div className="offer-filters__actions">
        <Button
          type="button"
          variant="secondary"
          onClick={onReset}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default OfferFilters;